<template>
  <div>
    <a-row style="margin-bottom: 5px">
      <a-col style="width: 137.6px; margin-right: 5px;">
        <div style="
          border: 1px solid #d1d1d1;
          background: #f2f2f2;
          border-radius: 4px;
          text-align: center;
          height: 32px;
          line-height: 32px;
        ">ZIP文件</div>
      </a-col>
      <a-col>
        <FileUpload
          url="/personApplications/import/save"
          fileField="file"
          :showList="false"
          :handelBeforeUpload="true"
          @beforeUpload="beforeUpload"
        >
          <a-button block>
            {{ file ? '重新上传(已上传)' : '+上传' }}
          </a-button>
        </FileUpload>
      </a-col>
    </a-row>
    <multiple_form
      :forms="forms"
      :edit="props.isEdit"
      :editData="props.editData"
      @submit="handelSubmit"
    />
  </div>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/person_application/person_batch_application'
  import multiple_form from '@/components/multiple_form'
  import FileUpload from '@/components/form/file_upload'

  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])
  const file = ref()

  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '',
      id: 'visitor',
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '导入任务名',
          width: '20vw',
        },
      ],
    },
  ])

  function beforeUpload(e) {
    const reader = new FileReader()

    reader.onload = (e) => {
      const binaryData = e.target.result // 获取二进制数据 (ArrayBuffer)
      file.value = binaryData
    }

    reader.readAsArrayBuffer(e) // 读取文件为 ArrayBuffer (二进制)
    return false
  }

  async function handelSubmit(data) {
    if (!file.value) return message.warn('请上传zip文件')
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const formData = new FormData()
    formData.append('zipFile', new Blob([file.value])) // 将 ArrayBuffer 包装为 Blob
    formData.append('name', data.name) // 其他需要传递的数据
    formData.append(
      'id',
      props.isEdit ? { [props.idField]: props.editData[props.idField] } : ''
    )
    const res = await ajaxFn(formData)
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
